<!-- 角色管理 -->
<template>
    <div class="basis-page-cls">
        <section class="basis-cls_filter">
            <table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
    
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 角色列表</span>
                <div class="btns">
                    <el-button @click.stop="addRole" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增角色</el-button>
                </div>
            </div>
            <div class="table">
                <table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getRoleList" />
            </div>
        </section>
 
        <roleManage ref="roleManage" @handleDone="getRoleList"/>
        <updateRole ref="updateRole"/>
        <roleAuth ref="roleAuth"/>
        
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import roleManage from "./components/roleManage";
    import updateRole from "./components/updateRole";
    import roleAuth from "./components/roleAuth";

    export default {
        components: {
            roleManage,
            updateRole,
            roleAuth
        },
        data() {
            return {
                column: [
                    { label: '角色', prop: 'roleName', minWidth: 120 },
                    { label: '品牌名称', prop: 'brandName', minWidth: 120 },
                    { label: '创建时间', prop: 'createTime', minWidth: 120 },
                    {
                        label: '角色属性', 
                        minWidth: 150,
                        render: (h, scope)=>{
                            let roleProp = "自定义角色";
                            if(['', null, undefined].includes(scope.row.brandId))
                                roleProp = "通用角色";
                            return <span>{roleProp}</span>
                        }
                    },
                    {
                        label: '描述',
                        minWidth: 100,
                        render: (h, scope) => {
                            return <span>{scope.row.description}</span>
                        }
                    },
                    /*{
                        label: '状态',
                        prop: 'customerId',
                        minWidth: 60,
                        render: (h, scope) =>{
                            let state = "正常";
                            if(scope.row.state == 0){
                                state = "正常";
                            }else if(scope.row.state == 1){
                                state = "锁定";
                            }
                            return <span>{state}</span>
                        }
                    },*/
                    {
                        label: '操作',
                        prop: 'cation',
                        align: 'center',
                        width: 300,
                        fixed: 'right',
                        render: (h, scope) => {
                            return (
                                <div>
                                    <el-button type="text" onClick={()=>this.customMenuList(scope.row)}>人员管理</el-button>
                                    {
                                        (this.userInfo.userType == '1' || !['', null, undefined].includes(scope.row.brandId))&&
                                            <el-button type="text" onClick={()=>this.editBrand(scope.row)}>修改</el-button>
                                    }
                                    <el-button type="text" onClick={()=>this.auth(scope.row)}>角色权限</el-button>
                                    {
                                        (this.userInfo.userType == '1' || !['', null, undefined].includes(scope.row.brandId))&&
                                            <el-button type="text" onClick={()=>this.delRole(scope.row)}>删除</el-button>
                                    }
                                </div>
                            )
                        }
                    }
                ],
                //--------------------------
                filterHeader: [
                    { label: '角色名称', model: 'roleName', type: 'input', default: '' },
                    { label: '品牌名称', model: 'brandName', type: 'input', default: '', placeholder: '请输入角色所属品牌' },
                    { label: '创建时间', model: 'datePicker', type: 'datetimerange', default: '' },
                    { label: '角色属性', model: 'commonRoles', type: 'select', default: '', list: [{
                        id: 1,
                        name: "通用角色"
                    },{
                        id: 0,
                        name: "自定义角色" 
                    }] },
                ],
                listQuery: {
                    pageNum: 1, // 当前页数
                    pageSize: 10, // 当前每页显示多少条数据
                    roleName: "",
                    brandName: "",
                    brandIdentify: '',
                    datePicker: "", // 日期选择器
                    commonRoles: ""
                },
                total: 0,
                list: [], // 角色列表
            }
        },
        computed: {
            ...mapGetters([
                'userInfo',
            ])
        },
        created() {
        },
        mounted() {
            this.initSearchCondition();
            this.getRoleList();
        },
        methods: {
            filterSearch(query) {
                this.listQuery = Object.assign(this.listQuery, query);
                this.getRoleList();
            },
            initSearchCondition(){
                if (this.userInfo.userType == 1) {
                    this.listQuery.commonRoles = 1;
                }
            },
            // 请求色角列表
            getRoleList() {
                this.$api.getRoleListSel({
                    data: {
                        assistantResId: "",
                        brandId: "",
                        brandIdentify: this.userInfo.brandIdentify,
                        brandName: this.listQuery.brandName || "",
                        createBy: "",
                        createTime: "",
                        createTimeFrom: this.listQuery.datePicker ? this.listQuery.datePicker[0] : '',
                        createTimeTo: this.listQuery.datePicker ? this.listQuery.datePicker[1] : '',
                        description: "",
                        isSelect: "",
                        menuList: [
                          ""
                        ],
                        parentRoleId: "",
                        roleId: "",
                        roleName: this.listQuery.roleName || "",
                        state: "",
                        commonRoles: this.listQuery.commonRoles
                    },
                    orderBy: 'create_time',
                    pageNum: this.listQuery.pageNum,
                    pageSize: this.listQuery.pageSize
                }).then(res => {
                    if(res.errcode != 0) return false;
                    this.list = res.list
                    this.total = res.total
                })
            },

            // 新增角色
            addRole() {
                this.$refs.roleManage.open("addRole");
            },
            // 人员管理列表
            customMenuList(row) {
                this.$refs.updateRole.open(row);
            },
            // 修改角色
            editBrand(row) {
                this.$refs.roleManage.open("updateRole",row);
            },
            // 角色权限
            auth(row) {
                this.$refs.roleAuth.open(row);
            },

            // 删除品牌
            delRole(roleData) {
                this.$confirm(`是否删除角色"${roleData.roleName}"？ 角色一经删除，将永久消失。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error',
                }).then(() => {
                    this.$api.deleteRoleDel(roleData.roleId).then(res => {
                        if(res.errcode != 0) return false;
                        this.getRoleList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })
                }).catch(() => {
                    /*this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });*/
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>